import React from "react";
import { JdsButton } from "../../../components/jds/JdsButton";
import { CloseIcon } from "../../../components/jds/icons";
import "../../../components/jds/jds.css";
import "../consultas.css";

// Diálogo JDS desta tela (mesmo padrão do UserDetailsConfirmModal). Precisa
// ser renderizado dentro de .jds-scope. Fecha só pelo botão, como o antigo
// Modal com backdrop estático e keyboard={false}.
export function ConsultasModal({ show, title, titleId, onClose, children }) {
  if (!show) return null;

  return (
    <div className="consultas-modal">
      <div
        className="consultas-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="consultas-modal__header">
          <h2 id={titleId} className="jds-title-md">
            {title}
          </h2>
          <JdsButton
            variant="ghost"
            color="neutral"
            size="sm"
            iconOnly
            aria-label="Fechar"
            title="Fechar"
            onClick={onClose}
          >
            <CloseIcon />
          </JdsButton>
        </div>
        {children}
      </div>
    </div>
  );
}
